export default __webpack_public_path__ + "static/media/helpd-icon.1dbc7eb2.svg";